/* @flow */
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';

export default class Invitation extends Entity {
  static isValidGroupInvite(groupId: Backbone$Id, address: string) {
    return apiRequest(`/classes/${groupId}/invitations/validate`, 'GET', {
      invitations: [
        {
          address,
        },
      ],
    });
  }

  static isValidOrgInvite(orgId: Backbone$Id, address: string) {
    return apiRequest(`/managed_orgs/${orgId}/invitations/validate`, 'GET', {
      invitations: [
        {
          address,
        },
      ],
    });
  }
}
